import { getLabel } from "../../../../../hooks/use-labels";
import { getStyle } from "../../../../../hooks/use-styles";

const DiscountFreeBadge = ({ discount, isFree }) => {
  if (discount <= 0 && !isFree) return null;

  return (
    <div
      className={`product-discount-text ${isFree && "blink text-upper-case"}`}
      style={{
        backgroundColor: getStyle(isFree ? "primaryColor" : "primaryPink"),
      }}
    >
      {!isFree
        ? `${discount.replaceAll(".00", "")}% Off`
        : getLabel("freeLabel")}
    </div>
  );
};

export default DiscountFreeBadge;
